import { render, staticRenderFns } from "./ecAddorDetail.vue?vue&type=template&id=6c1015b6&scoped=true&"
import script from "./ecAddorDetail.vue?vue&type=script&lang=js&"
export * from "./ecAddorDetail.vue?vue&type=script&lang=js&"
import style0 from "./ecAddorDetail.vue?vue&type=style&index=0&id=6c1015b6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1015b6",
  null
  
)

export default component.exports